module.exports = __webpack_public_path__ + "static/media/img-banner.912b29b5.svg";